import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "margin-b-standard" }

import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MediaContent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RightSidebarTitle, { title: 'Media Content' }),
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "not-supported-message" }, "This tool is no longer supported.", -1))
  ]))
}
}

})